import { Button } from "react-bootstrap";

import { BASE_URL } from "@/constants";
import { EXTERNAL_ROUTES } from "@/constants/routes";
import { isWebView } from "@/constants/webView";
import useLocalizedHref from "@/hooks/useLocalizedHref";

interface ILogoProps {
  width?: number | string;
  height?: number | string;
}

function Logo({ width = 86, height = 40 }: ILogoProps) {
  const localizedHref = useLocalizedHref();
  return (
    <Button
      as="a"
      variant="link"
      href={
        !isWebView
          ? localizedHref(`${BASE_URL}${EXTERNAL_ROUTES.HOME}`)
          : undefined
      }
      className="p-0 position-relative z-1"
    >
      <img
        src="/assets/logo.svg"
        alt="Me-QR Logo"
        width={width}
        height={height}
      />
    </Button>
  );
}

export default Logo;
